import React from 'react';
import { TouchableOpacity, type TouchableOpacityProps } from 'react-native';

import { theme } from '@garnish/constants';
import { Icon } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const NavbarFloatingMenuButton = (props: Props) => {
  const { accessibilityLabel, onPress } = props;

  // ─────────────────────────────────────────────────────────────────────

  return (
    <TouchableOpacity
      accessibilityLabel={accessibilityLabel}
      accessibilityRole="button"
      activeOpacity={0.7}
      hitSlop={theme.spacing['1']}
      onPress={onPress}
    >
      <Icon color={theme.colors.KALE} height={24} name="IconHamburger" width={24} />
    </TouchableOpacity>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  accessibilityLabel: string;
  onPress: NonNullable<TouchableOpacityProps['onPress']>;
};
